export const FILE_NAME = 'Products';
export const TABLET_WIDTH = 900;
